// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_gdV","cls2":"common-cls2_N_L common-cls1_gdV"};